import { Logger } from "../../02_utils/logger";
import { Utils } from "../../02_utils/utils";

export class Select {
  constructor(private $log: Logger, private $utils: Utils) {
    const selects: NodeListOf<HTMLElement> = document.querySelectorAll('.js-select');

    selects?.forEach(select => {
      this.initSelect(select);
    });

    this.initClickOutside(selects);
  }

  private initSelect(select: HTMLElement) {
    const button: HTMLElement = select.querySelector('.js-select-button');
    const options: NodeListOf<HTMLElement> = select.querySelectorAll('.js-select-option');
    const output = select.querySelector('.js-select-output');

    button?.addEventListener('click', () => {
      if (select.classList.contains('active')) {
        this.$utils.addOrRemoveClases('remove', 'active', select);
      } else {
        this.$utils.addOrRemoveClases('add', 'active', select);
      }
    }, {passive: true});

    options?.forEach(option => {
      option.addEventListener('click', () => {
        output.innerHTML = option.innerHTML;
        button.dataset.value = option.dataset.value
        this.$utils.addOrRemoveClases('remove', 'active', select);
      });
    });
  }

  private initClickOutside(selects: NodeListOf<HTMLElement>) {
    document.addEventListener('click', (event: Event) => {
      selects?.forEach(select => {
        if (!select.contains(event.target as Node)) {
          this.$utils.addOrRemoveClases('remove', 'active', select);
        }
      });
    }, {passive: true});
  }
}
